import React, { useState } from 'react';
import { Navbar, Footer } from '.';
import { CartDrawer } from '../components';

export default function PageContainer({ children }) {
  const [openCart, setOpenCart] = useState(false);

  return (
    <>
      <Navbar setOpenCart={setOpenCart} />
      <main>{children}</main>
      <Footer />
      <CartDrawer open={openCart} setOpen={setOpenCart} />
    </>
  );
}
